/**
 * Lomnická pekárna — Theme JavaScript
 */

// CSS entry — imported here so Vite's module graph tracks SCSS dependencies.
// In production, Rollup extracts this to dist/css/style.css.
import '../css/style.css';

// Import helpers and components
import { helpers } from './theme/helpers.js';
import { headerMenu } from './theme/components/header-menu.js';
import { scrollReveal } from './theme/components/scroll-reveal.js';
import { testimonialSlider } from './theme/components/testimonial-slider.js';
import { productFilter } from './theme/components/product-filter.js';

window.theme = {
    globals: {
        isTouch: typeof window !== 'undefined' && ('ontouchstart' in window || navigator.maxTouchPoints > 0),
    },

    helpers: helpers,

    init: function () {
        headerMenu.init();
        scrollReveal.init();
        testimonialSlider.init();
        productFilter.init();
    },
};

document.addEventListener('DOMContentLoaded', () => {
    window.theme.init();
});
